import { Component, EventEmitter, Output, ViewChild, AfterViewInit, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CalltrackerService } from 'src/app/services/operations/calltracker.service'
import { UserSessionService } from 'src/app/services/usersession.service';
import { ToastrService } from 'ngx-toastr';
import { IStore } from 'src/app/Shared/interface';
import { GridComponent, GridLine } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'app-relink-call',
  templateUrl: './relink-call.component.html',
  styleUrls: ['./relink-call.component.scss'],
  standalone: false
})
export class RelinkCallComponent implements AfterViewInit, OnInit {
  @Output() onRelinkSuccess = new EventEmitter<any>();
  @ViewChild('grid', { static: false }) public gridData: GridComponent;
  public loaderIcon: Promise<boolean>;
  public filterSettings = { type: 'FilterBar', mode: 'Immediate' };
  public lines: GridLine = 'Both';
  callData: any;
  loading = false;
  selectedRecord: any = null;
  searchModel = {
    facilityId: '',
    confirmationNumber: '',
    unitNumber: '',
    tenantName: '',
    phone: ''
  };
  allStores: IStore[] = [];
  resultList: any[] = [];
  selectedFacilityId: number | null = null;
  lastAccessedFacility;
  isCallCenterAgent = false;
  modalRef: BsModalRef;

  constructor(private callTrackerService: CalltrackerService,
    private userSessionService: UserSessionService,
    private toastr: ToastrService,
    private bsModalRef: BsModalRef,
    private modalService: BsModalService) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.gridData) return;
      const filterCells = this.gridData.element.querySelectorAll('.e-filterdiv');
      const columns = this.gridData.columns as any[];
      const selectIndex = columns.findIndex(c => c.headerText === 'Select');
      if (selectIndex !== -1 && filterCells[selectIndex]) {
        filterCells[selectIndex].classList.add('e-hide');
      }
    }, 0);
  }
  ngOnInit(): void {
    this.isCallCenterAgent = this.userSessionService.isCallcenterAgent;
    this.lastAccessedFacility = this.userSessionService.userSessionData?.LastAccessedStoreId;
    if (!this.isCallCenterAgent && this.lastAccessedFacility) {
      this.selectedFacilityId = this.lastAccessedFacility;
      this.searchModel.facilityId =
        this.lastAccessedFacility.toString();
    }
  }

  proceedRelink() {
    if (!this.selectedRecord) {
      return;
    }
    this.loading = true;
    const payload: any = {
      PhoneId: this.callData.PhoneId,
      PhoneSystem: this.callData.PhoneSystem,
      OutboundCall: this.callData.OutboundCall,
      CallCenterIntegrationId: this.callData.CallCenterIntegrationId,
      PhoneNumber: this.callData.CallerID,
      TrackingNumber: this.callData.TrackingNumber,
      CallSID: this.callData.RecordingID || this.callData.CallRecordingId,
      CallRecordingId: this.callData.RecordingID || this.callData.CallRecordingId,
      AdSourceID: this.callData.AdSourceID,
      ExistingTenantCall: this.callData.ExistingTenantCall,
      TenantID: this.selectedRecord.TenantId,
      FacilityId: this.selectedFacilityId,
      LeaseNumber: null,
      ReservationNumber: null,
      InquiryNumber: null,
      IncompleteCall : this.callData.IncompleteCall,
      IncompleteCallUserId: this.callData.IncompleteCallUserId,
      IncompleteCallConverted : this.callData.IncompleteCallConverted,
      IncompleteCallConvertedDateTime: this.callData.IncompleteCallConvertedDatetime,
      IncompleteCallConvertedUserId: this.callData.IncompleteCallConvertedUserId,
      CallDuration: this.callData.CallDuration
    };

    switch (this.selectedRecord.Type) {
      case 'RENTAL': payload.LeaseNumber = Number(this.selectedRecord.ConfirmationNumber);
        break;
      case 'RESERVATION': payload.ReservationNumber = Number(this.selectedRecord.ConfirmationNumber);
        break;

      case 'INQUIRY': payload.InquiryNumber = Number(this.selectedRecord.ConfirmationNumber);
        break;
    }

    this.callTrackerService.SavePhoneCall(payload).subscribe({
      next: () => {
        this.loading = false;
        this.modalRef.hide();
        this.onRelinkSuccess.emit({ success: true });
        this.bsModalRef.hide();
      },

      error: () => {
        this.loading = false;
        this.modalRef.hide();
        this.onRelinkSuccess.emit({ success: false });
        this.bsModalRef.hide();
      }
    });
  }
  cancel() {
    this.bsModalRef.hide();
    if (this.callData?.parentModal) {
      this.callData.parentModal.show();
    }
  }
  searchTenantRecords() {
    const payload = {
      facilityId: this.selectedFacilityId,
      confirmationNumber: this.searchModel.confirmationNumber,
      unitNumber: this.searchModel.unitNumber,
      tenantName: this.searchModel.tenantName,
      phoneNumber: this.searchModel.phone
    };
    this.loading = true;
    this.callTrackerService.GetTenantRecordsToRelink(payload).subscribe({
      next: (res: any[]) => {

        this.resultList = res || [];
        this.selectedRecord = null;
        this.loading = false;
        if (!this.resultList.length) {
          this.toastr.warning('No records found');
        }
      },
      error: () => {
        this.loading = false;
        this.toastr.error('Failed to fetch records');
      }
    });

  }
  onSelectRecord(data: any) {
    this.selectedRecord = data;
  }

  canSearch(): boolean {
    return !!(
      this.selectedFacilityId &&
      (
        this.searchModel.confirmationNumber ||
        this.searchModel.unitNumber ||
        this.searchModel.tenantName ||
        this.searchModel.phone
      )
    );
  }
  formatPhoneNumber(phone: string): string {
    if (!phone) {
      return '';
    }

    const matches = phone.match(/\d{10}\s*\([CHWB]\)/g);
    const phones: string[] = [];

    matches?.forEach(item => {
      const digits = item.match(/\d{10}/)?.[0];
      const suffix = item.match(/\([CHWB]\)/)?.[0] ?? '';

      if (digits) {
        phones.push(
          `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)} ${suffix}`
        );
      }
    });

    if (phones.length > 2) {
      return `${phones[0]} / ${phones[1]} /\n${phones.slice(2).join(' / ')}`;
    }
    return phones.join(' / ');
  }
  openRelinkConfirmation(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-dialog-centered modal-sm'
    });
  }
}